import * as Sentry from "@sentry/vue"

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN

export const SentryInit = (app) => {
  
  Sentry.init({
    beforeSend(event, hint) {
      // Filter out unhandled rejections with no meaningful value (e.g. Promise.reject(undefined))
      const isUnhandledRejection = hint?.originalException === undefined || hint?.originalException === null
      const isPromiseRejectionEvent = event.exception?.values?.[0]?.type === 'UnhandledRejection' ||
        event.exception?.values?.[0]?.value?.includes('CustomEvent')
      if (isUnhandledRejection && isPromiseRejectionEvent) {
        return null
      }

      // Filter out image load errors
      if (event.exception?.values?.[0]?.value?.includes("Image failed to load!And failed src was")) {
        return false
      }

      // Add additional context
      if (event.user) {
        // User context already set
      }

      // Add custom tags for better filtering in Sentry
      event.tags = {
        ...(event.tags || {}),
        environment: import.meta.env.MODE || 'development',
        component: hint?.component?.__name || 'unknown',
      }

      return event
    },
    app,
    dsn: SENTRY_DSN,
    
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  
    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", "http://dev.cdp2.torpedo.io", /^https:\/\/yourserver\.io\/api/],
  
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [/^Image failed to load!And failed src was$/, 'Request aborted', 'Failed to fetch'],
    denyUrls: [],
    
    // Automatically attach user info
    attachStacktrace: true,
    
    // Capture unhandled promise rejections
    captureUnhandledRejections: true,
  })
}

// Helper function to set user context (call this when user logs in)
export const setSentryUser = (user) => {
  Sentry.setUser({
    id: user?.id,
    email: user?.email,
    username: user?.username || user?.name,
  })
}

// Helper function to add breadcrumbs
export const addBreadcrumb = (message, category = 'custom', level = 'info', data = {}) => {
  Sentry.addBreadcrumb({
    message,
    category,
    level,
    data,
    timestamp: Date.now() / 1000,
  })
}

// Helper function to manually capture exceptions with context
export const captureException = (error, context = {}) => {
  Sentry.withScope((scope) => {
    // Add custom context
    Object.keys(context).forEach(key => {
      scope.setContext(key, context[key])
    })
    Sentry.captureException(error)
  })
}